<template>
  <KPopup width="fit-content" :fullscreen="false">
    <template #popup:incidents_layer="{ feature, coordinates }">
      <IncidentPopup :feature="feature" :coordinates="coordinates" />
    </template>
  </KPopup>
</template>

<script setup lang="ts">
import { KPopup } from '@tsyl/karonte-widgets'

import IncidentPopup from '@/components/Popups/IncidentPopup.vue'
</script>
